/* SandyClair — mejoras propias de tienda.
   1) "Completa el look" dentro del carrito desplegable (añadir sin recargar).
   2) Nombre del color en la ficha: se actualiza también al pasar el ratón.

   Todo va con delegación en `document`, así los bloques siguen funcionando
   después de cada repintado AJAX del drawer (que reemplaza el HTML entero). */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* 1. Upsell del carrito desplegable                                   */
  /* ------------------------------------------------------------------ */

  function cartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  function setButtonBusy(button, busy) {
    button.disabled = busy;
    button.classList.toggle('is-loading', busy);
  }

  function onUpsellClick(event) {
    var button = event.target.closest ? event.target.closest('[data-sc-upsell-add]') : null;
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var root = button.closest('[data-sc-upsell]');
    var errorEl = root ? root.querySelector('[data-sc-upsell-error]') : null;
    if (errorEl) errorEl.textContent = '';

    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    setButtonBusy(button, true);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        // Shopify devuelve `status` sólo cuando algo ha fallado (agotado, límite…)
        if (state.status) {
          setButtonBusy(button, false);
          if (errorEl) {
            errorEl.textContent = state.description || state.message || 'No se ha podido añadir.';
          }
          return;
        }

        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          // Repinta todo el drawer con Liquid: totales, barra de envío y este
          // mismo bloque (que así deja de mostrar el producto recién añadido).
          drawer.renderContents(state);
        } else {
          window.location.reload();
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sc-cart-upsell',
            productVariantId: variantId,
            cartData: state
          });
        }
      })
      .catch(function () {
        setButtonBusy(button, false);
        if (errorEl) errorEl.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
      });
  }

  // Flechas del carrusel: avanzan un producto; al final vuelve al primero.
  function onUpsellMove(event) {
    var button = event.target.closest ? event.target.closest('[data-sc-upsell-mover]') : null;
    if (!button) return;
    event.preventDefault();

    var root = button.closest('[data-sc-upsell]');
    var track = root ? root.querySelector('[data-sc-upsell-pista]') : null;
    if (!track || !track.clientWidth) return;

    var step = track.clientWidth;
    var max = track.scrollWidth - step;
    var dir = parseInt(button.getAttribute('data-sc-upsell-mover'), 10) || 1;
    var target = Math.round(track.scrollLeft / step) * step + dir * step;
    if (target > max + 2) target = 0;
    else if (target < -2) target = max;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
  }

  // Desplegable de variante: cambia la variante que añade el botón, el precio y la foto.
  function onUpsellSelect(event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-sc-upsell-select]')) return;

    var slide = select.closest('[data-sc-upsell-slide]');
    var option = select.options[select.selectedIndex];
    if (!slide || !option) return;

    var button = slide.querySelector('[data-sc-upsell-add]');
    if (button) button.setAttribute('data-variant-id', option.value);

    var price = slide.querySelector('[data-sc-upsell-precio]');
    if (price && option.getAttribute('data-precio')) price.textContent = option.getAttribute('data-precio');

    var before = slide.querySelector('[data-sc-upsell-antes]');
    if (before) {
      before.textContent = option.getAttribute('data-antes') || '';
      before.hidden = !option.getAttribute('data-antes');
    }

    var img = slide.querySelector('[data-sc-upsell-img]');
    if (img && option.getAttribute('data-img')) img.src = option.getAttribute('data-img');
  }

  /* ------------------------------------------------------------------ */
  /* 2. Nombre del color al pasar el ratón por una muestra               */
  /* ------------------------------------------------------------------ */

  // Muestras nativas de Dawn, las nuestras del mapa de colores, y las de la
  // ficha propia (sección sc-producto).
  var SWATCH_LABEL = [
    '.product-form__input--swatch .swatch-input__label',
    '.product-form__input--sc-swatch .sc-swatch-input__label',
    '.sc-options__values--color .sc-swatch--color'
  ].join(', ');

  function swatchContext(label) {
    var field = label.closest('.product-form__input') || label.closest('.sc-options');
    if (!field) return null;
    return {
      field: field,
      output: field.querySelector('[data-selected-value], [data-sc-option-value]')
    };
  }

  // El nombre del color: el value del radio, o el data-value del botón propio.
  function swatchValue(label) {
    if (label.hasAttribute('data-value')) return label.getAttribute('data-value');
    var input = document.getElementById(label.getAttribute('for'));
    return input ? input.value : null;
  }

  function selectedValue(field) {
    var checked = field.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var active = field.querySelector('.sc-swatch.is-selected');
    return active ? active.getAttribute('data-value') : null;
  }

  function onSwatchOver(event) {
    if (!event.target.closest) return;
    var label = event.target.closest(SWATCH_LABEL);
    if (!label) return;

    var ctx = swatchContext(label);
    if (!ctx || !ctx.output) return;

    var name = swatchValue(label);
    if (name) ctx.output.textContent = name;
  }

  function onSwatchOut(event) {
    if (!event.target.closest) return;
    var label = event.target.closest(SWATCH_LABEL);
    if (!label) return;

    var ctx = swatchContext(label);
    if (!ctx || !ctx.output) return;

    // La verdad siempre es el valor marcado; Dawn ya lo actualiza al seleccionar.
    var name = selectedValue(ctx.field);
    if (name) ctx.output.textContent = name;
  }

  // La ficha propia (sc-producto) no tiene el hook de Dawn: al hacer clic,
  // sc-scripts.js mueve `is-selected` y aquí refrescamos la etiqueta.
  function onScSwatchClick(event) {
    if (!event.target.closest) return;
    var button = event.target.closest('.sc-options__values--color .sc-swatch--color');
    if (!button) return;
    setTimeout(function () {
      var ctx = swatchContext(button);
      if (!ctx || !ctx.output) return;
      var name = selectedValue(ctx.field);
      if (name) ctx.output.textContent = name;
    }, 0);
  }

  /* ------------------------------------------------------------------ */

  document.addEventListener('click', onUpsellClick);
  document.addEventListener('click', onUpsellMove);
  document.addEventListener('change', onUpsellSelect);
  document.addEventListener('click', onScSwatchClick);
  document.addEventListener('mouseover', onSwatchOver);
  document.addEventListener('mouseout', onSwatchOut);
})();
